import { constants } from '../../data/languages';
import { setLanguageUrl } from '../../utils/languageUrl';
import s from './LanguagePopup.scss';
import { CloseIcon } from './CloseIcon';
import { HFConfig } from '../../config';

interface LanguagePopupProps {
  config: HFConfig;
}
export const LanguagePopup = ({ config: { languageRedirectUrl, language: currentLanguage } }: LanguagePopupProps) => {
  const dataBiRow = 'languages';
  return `
    <div class="${s.container}" data-hook="language-popup">
      <div class="${s.container2}">
        <ul class="${s.languages}"  data-hook="language-list">
          ${constants.languages
            .map((language, index) => {
              const url = setLanguageUrl({
                language: language.name || '',
                location: window.location,
                languageRedirectUrl,
              });
              return `
              <li class="${s.language} ${index >= 14 ? s.lastColumn : ''}">
                <a
                  class="${s.link} ${s.biLink} ${language.name === currentLanguage ? s.selected : ''}"
                  href="${url}"
                  data-bi-name="${language.name}"
                  data-bi-row="${dataBiRow}"
                >
                  ${language.text}
                </a>
              </li>
            `;
            })
            .join('')}
        </ul>
        <a
          class="${s.closeButton}"
          data-hook="close-language-picker"
          data-bi-row="${dataBiRow}"
          data-bi-name="close"
          role="button"
          href="#"
        >
          ${CloseIcon()}
        </a>
      </div>
    </div>
  `;
};
